<template>
  <Panel class="financial-overview indication-charts tw-pt-0">
    <template #title>
      Origem do paciente
    </template>

    <template #controls>
      <period-selector
        :company-created-at="companyCreatedAt"
        :selected-month="selectedMonth"
        @selected-month="selectedMonth = $event"
        :type="periodType"
        @type="periodType = $event"
        :selected-year="selectedYear"
        @selected-year="selectedYear = $event"
      />
    </template>

    <div v-if="dataSet.length === 0 && loading == false && loaded == true" class="tw-text-center">
      <p class="tw-font-semibold  tw-text-xl">
        Sem dados suficientes para exibir o gráfico.
      </p>
      <small>Cadastre a origem de alguns pacientes depois volte aqui :)</small>
    </div>
    <div class="tw-relative">
      <img v-bind:src="railsImage" v-if="loading == true" class="tw-absolute tw-right-1/2 tw-translate-x-1/2 tw-z-10" >
      <div class="md:tw-w-3/12 tw-hidden">
        <ul class="tw-space-y-2 indication-list">
          <li v-for="serie in dataSet" :key="serie.name_value" class="indication-item tw-cursor-pointer" :data-meta="serie.meta">
            <div class="tw-text-base tw-flex tw-items-center">
              <div :class="`indication-bg-${serie.name_value} tw-h-5 tw-w-5 tw-rounded-full tw-mr-2`"></div>
              {{serie.name}} {{serie.percent}}%
            </div>
            <small class="tw-block tw-text-gray-600 tw-text-sm tw-ml-7">{{serie.value}} pacientes</small>
          </li>
        </ul>
      </div>
      <div class="md:tw-w-full">
        <PieChart :chartData="dataSet" style="height: 500px" class=""/>
      </div>
    </div>
  </Panel>
</template>
<script>
import axios from "axios";
import PieChart from '../charts/pie-chart.vue'
import PeriodSelector from "../form/period-selector"
import railsImage from 'images/spinner.svg';
import Panel from "../panel"

const colors = {
  instagram: "#fdba74",
  facebook: "#67e8f9",
  google: "#fde047",
  family_indication: "#86efac",
  friend_indication: "#059669",
  dentist_indication: "#064e3b",
  newspaper: "#a5b4fc",
  outdoor: "#ef4444",
  radio: "#22c55e",
  tv: "#eab308",
  dental_plan: "#d8b4fe",
  website: "#06b6d4",
  other: "#78716c",
}

export default {
  props: {
    companyCreatedAt: String,
    year: Number,
    hasFinancialFeature: Boolean
  },
  components: {
    PieChart,
    PeriodSelector,
    Panel
  },
  data() {
    return {
      railsImage,
      selectedMonth: moment().month() + 1,
      selectedYear: moment().year(),
      periodType: "all",
      loaded: false,
      loading: false,
      dataSet: []
    };
  },
  computed: {
  },
  mounted() {
    setTimeout(() => this.fetch(), 350)
  },
  watch: {
    selectedMonth() {
      this.fetch();
    },
    selectedYear() {
      this.fetch();
    },
    periodType() {
      this.fetch();
    }
  },
  methods: {
    fetch() {
      this.loaded = true
      this.loading = true

      const params = {
      }

      if (this.periodType == "monthly") {
        params.month = this.selectedMonth
      }

      if (this.periodType != "all") {
        params.year = this.selectedYear
      }
      axios
        .get(
          '/insights/indication', {params}
        )
        .then(response => {
          const totalPatients = response.data.total_patients
          response.data.dataset = response.data.dataset.series.map(item => ({
            ...item,
            percent: +((item.value * 100) / totalPatients).toFixed(2),
            itemStyle: {
              color: colors[item.name_value]
            }
          })).sort((a,b) => b.percent - a.percent)
          this.dataSet = response.data.dataset;
          this.loading = false

          if (this.periodType == "all") {
            this.$emit(this.dataSet.length === 0 ? "add-hint" : "remove-hint", {
              id: "no-indication",
              text: "Informar a origem dos pacientes pode te ajudar a entender o melhor canal a investir para captar novos pacientes."
            })
          }
        });
    }
  }
};
</script>
